export default __webpack_public_path__ + "static/team-member-06-370x250-8e8495b203e223779dd663f186fd7232.jpg";